import Vue from 'vue'
import './plugins'
import App from './App.vue'
import router from './router'
import store from './store'
import { isShowAppBar, isInAppWebview } from '@/utils/bridge'
import { APP_PATH_BACK } from '@/configs/app'
import Vant, {Toast} from 'vant';
import 'vant/lib/index.css';
import VueClipboard from 'vue-clipboard2'

Vue.use(VueClipboard)
Vue.use(Vant);
// 将所有 loading Toast 设置为背景不可点击 (2.2.10 版本开始支持)
Toast.setDefaultOptions('loading', { forbidClick: true });

let homeScrollTop = 0;
Vue.prototype.$homeScroll = homeScrollTop;

Vue.config.productionTip = false

Vue.prototype.$isShowAppBar = isShowAppBar

Vue.prototype.$navBack = function () {
    if (isInAppWebview()) {
        window.open(APP_PATH_BACK)
    } else {
        router.back()
    }
}

Vue.prototype.$navReload = function () {
    window.location.reload()
}

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
